<template>
  <div class="row">
    <div class="col-12" v-if="Object.keys(subscription).length !== 0">
      <a :href="redirectPortalUrl">
        我的订阅：{{ subscription.type }} --
        {{ subscription.created_at | moment("from") }}订阅
        <span v-if="subscription && subscription.stripe_status === 'canceled'">
          (已取消）
        </span>
      </a>
      <p
        v-if="subscription.ends_at && subscription.stripe_status != 'canceled'"
      >
        当前订阅停止时间：{{ subscription.ends_at | moment("from") }}
      </p>
      <br />
      <br />
    </div>
    <div class="col-12">
      <SubscriptionTable></SubscriptionTable>
    </div>
    <br />
  </div>
</template>

<script>
import SubscriptionTable from "@/components/SubscriptionTable";

export default {
  data() {
    return {
      subscription: {},
      userKey: Math.random(),
      month: true,
      redirectPortalUrl: ""
    };
  },
  components: {
    SubscriptionTable
  },
  methods: {
    fetchPaymentUI: function() {
      this.$http
        .get(`/user/subscription/portal`)
        .then(res => (this.redirectPortalUrl = res.data));
    },
    fetchUserSubscriptionStatus: function() {
      this.$http.get(`/user/subscription`).then(res => {
        this.subscription = res.data;
        this.fetchPaymentUI();
      });
    }
  },
  mounted: function() {
    this.fetchUserSubscriptionStatus();
  }
};
</script>

<style scoped></style>
